import { Link } from '@components/DetailsDialog/components/UpdateDescription/UpdateDescription.styles';
import { NormalComponents } from 'react-markdown/lib/complex-types';

export const A: NormalComponents['a'] = props => {
  const { children, ...rest } = props;
  return (
    <Link target="_blank" rel="noreferrer noopener" {...rest}>
      {children}
    </Link>
  );
};
